<template>
  <div class="layout">
    <!-- 上面导航 -->
    <div class="sidebat">
      <Sidebar></Sidebar>
    </div>
    <!-- 中间内容 -->
    <div class="content" :class="{ small: isCollapse }">
        <div class="footer">
          <Footer></Footer>
        </div>
      <div class="con">
        <Content @changeShow="changeShow" :isCollapse="isCollapse"></Content>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Sidebar from "./sidebar/Index.vue";
import Content from "./content/Index.vue";
import Footer from "./footer/Index.vue";

export default {
  name: "layoutIndex", // 修改为多词的组件名称
  components: {
    Sidebar,
    Content,
    Footer,
  },
  data() {
    return {
      isCollapse: false, // 根据需要设置初始值
    };
  },
  methods: {
    changeShow() {
      this.isCollapse = !this.isCollapse;
    },
  },
};
</script>
  
  <style>
.content {
  display: flex;
}
.sidebat {
  padding-bottom: 60px;
}
.con{
  margin-left: 200px;
  flex: 1;
}

.footer {
  position: fixed;
  margin-top: 4px;
}

.small {
  padding-left: 64px;
}
/* 响应式适配 - 移动端 */
@media (max-width: 768px) {
  .footer {
    width: auto;
  }
  .con{
  margin-left: 0;
}
}
</style>